module.exports = __webpack_public_path__ + "img/ring_y_c_null_null.dbdb482c.png";